module.exports = 'ontouchstart' in global || (global.DocumentTouch && document instanceof DocumentTouch)